/* eslint-disable react-hooks/exhaustive-deps */
import { CheckSquareOutlined, EditOutlined } from '@ant-design/icons';
import LoadableContainer from '@components/LoadableContainer';
import SplashScreen from '@components/SplashScreen';
import TitleWithText from '@components/TitleWithText';
import { useAppDispatch, useAuthState, useSubscriptionState } from '@core/configureStore';
import { checkout } from '@core/features/subscription/thunks/checkout.thunk';
import { manageSubscription } from '@core/features/subscription/thunks/manageSubscription.thunk';
import { formatUtcDate } from '@utils/.';
import { Button, Card, Col, Divider, Form, Input, Row } from 'antd';
import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router';

type Props = {};

const SubscriptionScreen = (props: Props) => {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const [noLicenses, setNoLicenses] = useState(1);
  const [updateLicense, setUpdateLicense] = useState(false);
  const { user } = useAuthState();
  const { isLoading } = useSubscriptionState();
  const { checkout_action } = useParams<{ checkout_action: string }>();

  const getLicenseDetails = () => {
    if (user?.no_licenses) {
      return user.no_licenses > 1 ? `Agency - ${user.no_licenses} licenses` : 'Pro';
    }
    return 'Starter';
  };

  const getSubscriptionText = () => {
    if (!user) return '';
    if (user.subscription_renewable) {
      return 'Next Billing Date';
    }
    return user.no_licenses && user.no_licenses > 0
      ? 'Subscription End Date'
      : 'Subscription Ended On';
  };

  const handleInputChange = (e: any) => {
    const { name, value } = e.target;
    setNoLicenses(value);
  };

  const handleCheckout = async () => {
    await dispatch(checkout(noLicenses));
  };

  const handleManageSubscription = async () => {
    if (!user) return;
    if (user.no_licenses && user.no_licenses > 0) {
      await dispatch(manageSubscription());
    } else {
      // Create new subcription if previous license has been cancelled
      await dispatch(checkout(1));
    }
  };

  return (
    <div className="screen-card">
      <h3>Billings</h3>
      <Divider />
      <LoadableContainer isLoading={isLoading} loadComponent={<SplashScreen />}>
        <React.Fragment>
          <Card
            className="tablespace mb-24"
            title={'Licenses'}
            style={{ width: 'full', marginBottom: '10px' }}>
            <Divider style={{ margin: 0, marginBottom: 20 }} />
            <div style={{ padding: '20px 20px' }}>
              {checkout_action === 'success' && (
                <div>
                  Thank you for using Review Circle. An email will be sent to you once the order is
                  processed. Please send us a message if you have any further question.
                </div>
              )}

              {checkout_action === 'cancelled' && (
                <div>
                  Your checkout is not being proccessed. Please send us a message if you need any
                  further assistance
                </div>
              )}

              <div
                style={{
                  display: 'flex',
                  alignItems: 'baseline',
                  paddingBottom: '6px',
                }}>
                <TitleWithText title="License Type">{`${getLicenseDetails()}`}</TitleWithText>
                {getLicenseDetails() === 'Starter' && (
                  <Button
                    type="link"
                    icon={updateLicense ? <></> : <EditOutlined />}
                    onClick={() => setUpdateLicense(!updateLicense)}>
                    {updateLicense ? 'Cancel' : 'Update'}
                  </Button>
                )}
              </div>

              {user?.subscription_end && (
                <div style={{ paddingBottom: '10px' }}>
                  <TitleWithText title={getSubscriptionText()}>
                    {formatUtcDate(user.subscription_end)}
                  </TitleWithText>{' '}
                  <br />
                  <Button
                    type="primary"
                    htmlType="button"
                    icon={<CheckSquareOutlined />}
                    onClick={() => handleManageSubscription()}>
                    {user?.subscription_renewable ? 'Manage Subscription' : 'Renew Subscription'}
                  </Button>
                </div>
              )}

              {updateLicense && (
                <Form form={form} name="owner_form" onFinish={handleCheckout}>
                  <Row gutter={5}>
                    <Col lg={6} md={12}>
                      <Form.Item
                        name="no_licenses"
                        initialValue={noLicenses}
                        rules={[
                          { required: true, message: 'Please enter the number of licenses' },
                        ]}>
                        <Input
                          name="no_licenses_input"
                          addonBefore="Number of Licenses"
                          onChange={handleInputChange}
                        />
                      </Form.Item>
                    </Col>
                    <Col lg={6} md={12}>
                      <Button type="primary" htmlType="submit" icon={<CheckSquareOutlined />}>
                        Subscribe
                      </Button>
                    </Col>
                  </Row>
                </Form>
              )}
            </div>
          </Card>
        </React.Fragment>
      </LoadableContainer>
    </div>
  );
};

export default SubscriptionScreen;
